export const OPEN = 'MENU_OPEN'
export const CLOSE = 'MENU_CLOSE'
export const MOBILE = 'MOBILE'
